/// <amd-module name="Test/TestPlansHubRefresh/TestSuiteImportPanel/Redux/TestSuiteImportPanelModule" />
import { ISagaModule } from "redux-dynamic-modules-saga";
import { TestSuiteImportPanelSaga } from "./TestSuiteImportPanelSaga";
import { TestSuiteImportPanelReducer } from "./TestSuiteImportPanelReducer";
import { ITestSuiteImportPanelAwareState } from "./TestSuiteImportPanelContracts";
import { TestHubRefreshReducer } from "Test/TestPlansHubRefresh/TestHub/Redux/TestHubRefresh/TestHubRefreshReducer";

export const TestSuiteImportPanelModule: ISagaModule<ITestSuiteImportPanelAwareState> = {
    id: "testsuite-import-panel",
    reducerMap: {
        testSuiteImportPanelState: TestSuiteImportPanelReducer,
        testHubRefreshState: TestHubRefreshReducer
    },
    sagas: [TestSuiteImportPanelSaga]
};
